import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  static get host(): string {
    return environment.api;
  }

  protected get getimportantUpdate(): string {
    return UrlService.host + 'small/sections/';
  }
  protected get importantUpdate(): string {
    return UrlService.host + 'small/section/';
  }
  protected get getevent(): string {
    return UrlService.host + 'upcomming/sections/';
  }
  protected get event(): string {
    return UrlService.host + 'upcomming/section/';
  }
  protected get getlatestNews(): string {
    return UrlService.host + 'latest/news/sections/';
  }
  protected get latestNews(): string {
    return UrlService.host + 'latest/news/section/';
  }
  protected get getheroSection(): string {
    return UrlService.host + 'main/sections/';
  }
  protected get herosection(): string {
    return UrlService.host + 'main/section/';
  }
  protected get heromobsection(): string {
    return UrlService.host + 'main/mobile/section/';
  }

  protected get getexternallink(): string {
    return UrlService.host + 'external/link/sections/';
  }
  protected get externallink(): string {
    return UrlService.host + 'external/link/section/';
  }
  protected get getgallerysection(): string {
    return UrlService.host + 'gallery/sections/';
  }
  protected get gallerysection(): string {
    return UrlService.host + 'gallery/section/';
  }
  protected get getwhoisWho(): string {
    return UrlService.host + 'whos/who/sections/';
  }
  protected get whoisWho(): string {
    return UrlService.host + 'whos/who/section/';
  }
  protected get updatedDate(): string {
    return UrlService.host + '/latest/updated/at';
  }
  protected get vistorCount(): string {
    return UrlService.host + '/iplogs';
  }
}
